module.exports = __webpack_public_path__ + "media/images/welldonetutor-1ce08af4.png";